import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { MediaRight } from 'foundations-components/transitional/components/MediaRight';
import Accordion from './components/Accordion';
import Alert from './components/Alert';
import CTA from './components/CTA';
import Card from './components/Card';
import CardsRow from './components/CardsRow';
import Code from './components/Code';
import Column from './components/Column';
import Endpoint from './components/Endpoint';
import EndpointCard from './components/EndpointCard';
import EndpointExample from './components/EndpointExample';
import EndpointHeader from './components/EndpointHeader';
import EndpointJSONFields from './components/EndpointJSONFields';
import EndpointLeftColumn from './components/EndpointLeftColumn';
import EndpointParameter from './components/EndpointParameter';
import EndpointParameters from './components/EndpointParameters';
import EndpointRequirements from './components/EndpointRequirements';
import EndpointRightColumn from './components/EndpointRightColumn';
import Form from './components/Form';
import GitHubEmbed from './components/GitHubEmbed';
import HubspotVideoPlayer from './components/HubspotVideoPlayer';
import IFrame from './components/IFrame';
import Image from './components/Image';
import Link from './components/Link';
import MdxH1 from './components/MdxH1';
import MdxH2 from './components/MdxH2';
import MdxH3 from './components/MdxH3';
import MdxH4 from './components/MdxH4';
import MdxH5 from './components/MdxH5';
import MdxH6 from './components/MdxH6';
import { MdxP } from './components/MdxP';
import PostmanButton from './components/PostmanButton';
import Pre from './components/Pre';
import ProductTier from './components/ProductTier/ProductTier';
import Quote from './components/Quote';
import RelatedApiLink from './components/RelatedApiLink';
import Row from './components/Row';
import Tab from './components/Tab';
import Table from './components/Table';
import Tabs from './components/Tabs';
import Tag from './components/Tag';
import Video from './components/Video';
import LegacyContentCard from './components/legacy/ContentCard';
import LegacyContentCardsRow from './components/legacy/ContentCardsRow';
import LegacyDndModule from './components/legacy/DndModule';
import LegacyDndSection from './components/legacy/DndSection';
export const mdxComponents = {
  Accordion,
  h1: MdxH1,
  h2: MdxH2,
  h3: MdxH3,
  h4: MdxH4,
  h5: MdxH5,
  h6: MdxH6,
  p: MdxP,
  img: Image,
  button: Button,
  table: Table,
  Table,
  a: Link,
  Alert,
  Card,
  CardsRow,
  code: Code,
  Column,
  ContentCard: LegacyContentCard,
  ContentCardsRow: LegacyContentCardsRow,
  CTA,
  DndModule: LegacyDndModule,
  DndSection: LegacyDndSection,
  Endpoint,
  EndpointCard,
  EndpointExample,
  EndpointHeader,
  EndpointLeftColumn,
  EndpointParameter,
  EndpointParameters,
  EndpointRequirements,
  EndpointRightColumn,
  GitHubEmbed,
  Icon: IconHolder,
  Illustration,
  EndpointJSONFields,
  Media,
  MediaBody,
  MediaLeft,
  MediaRight,
  PostmanButton,
  pre: Pre,
  ProductTier,
  Quote,
  Row,
  RelatedApiLink,
  Tab,
  Tabs,
  Tag,
  Video,
  HubspotVideoPlayer,
  IFrame,
  Form
};